module.exports = __webpack_public_path__ + "img/vol04_character_text02_sp.57ed9021.png";